import { TipoOcorrencia } from '@acme/core'
import { FormFieldAutocomplete } from 'global/components/Form'
import { HeartPulseIcon } from 'lucide-react'
import { ocorrencia } from 'service/api'
import { type CondicaoUi, contar } from './condicao-ui'

function ParametrosAfastamento() {
    const { data: ocorrencias = [] } = ocorrencia.useFetch()
    const afastamentos = ocorrencias.filter(
        it => it.tipo === TipoOcorrencia.AFASTAMENTO,
    )
    const descricaoPorId = new Map(
        afastamentos.map(it => [it.id, it.descricao]),
    )

    return (
        <FormFieldAutocomplete
            name="parametros.ocorrenciaIds"
            label="Ocorrências"
            multiple
            placeholder="Qualquer ocorrência"
            options={afastamentos.map(it => it.id)}
            getOptionLabel={(id: number) => descricaoPorId.get(id) ?? ''}
            getOptionKey={(id: number) => String(id)}
            isOptionEqualToValue={(opcao, valor) => opcao === valor}
        />
    )
}

export const afastamento: CondicaoUi = {
    icone: HeartPulseIcon,
    parametrosIniciais: { ocorrenciaIds: [] },
    Parametros: ParametrosAfastamento,
    resumir: parametros => {
        const ids = parametros.ocorrenciaIds as unknown[] | undefined
        return ids?.length
            ? contar(ids, 'ocorrência', 'ocorrências')
            : 'Qualquer ocorrência'
    },
}
